"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var override_service_1 = require("@services/overrides/override-service");
var environment_1 = require("@shared/types/environment");
var view_routes_1 = require("@shared/types/error-messages/view-routes");
var angular_1 = require("angular");
var error_message_html_1 = __importDefault(require("./error-message.html"));
require("./error-message.less");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    'use strict';
    ErrorMessageController.$inject = [
        '$filter',
        '$window',
        '$sce',
        'rsEnvironment',
        'prReportMenuService',
        'prCreateReportModal',
        'prClassicURLService',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS'
    ];
    function ErrorMessageController($filter, $window, $sce, env, reportMenu, createModal, classicURLService, triggerOverrides) {
        var $ctrl = this;
        var translate = $filter('translate');
        var configFlags = triggerOverrides({
            event: override_service_1.OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {} // default
        });
        var FAILED_TO_CREATE_NEW_REPORT = 'FAILED_TO_CREATE_NEW_REPORT';
        angular_1.extend($ctrl, {
            $onInit: function () {
                $ctrl.disableReportErrorMessageButtons =
                    !!configFlags.disableReportErrorMessageButtons &&
                        $ctrl.errorCode === view_routes_1.ErrorCode.NoViewResultsPermission;
                $ctrl.menuItems = reportMenu.getMenuItems();
            },
            getErrorMessage: function () {
                var res = translate('ERROR_MESSAGE.GENERIC');
                if ($ctrl.errorCode === view_routes_1.ErrorCode.NoViewResultsPermission) {
                    res = translate('ERROR_MESSAGE.LACKING_VIEW_RESULTS_PERMISSION', {
                        surveys: getSurveys()
                    });
                }
                return $sce.trustAsHtml(res);
            },
            showOtherReports: function () {
                return !lodash_1.default.includes([
                    FAILED_TO_CREATE_NEW_REPORT,
                    view_routes_1.ErrorCode.NoDashboardOrContainer
                ], $ctrl.errorCode);
            },
            backToProjects: function () {
                $window.location = '/Q/MyProjectsSection';
            },
            createReport: function () {
                createModal.show();
            },
            classicURL: classicURLService.getClassicURL(),
            canAccessLegacyReports: !!env.get(environment_1.ENV_VARS.PERMISSIONS).canAccessLegacyReports
        });
        function getSurveys() {
            var surveyId = '';
            var envError = env.get(environment_1.ENV_VARS.ERROR);
            if (envError && envError.data) {
                surveyId = envError.data;
                if (lodash_1.default.isArray(surveyId)) {
                    surveyId = lodash_1.default.join(surveyId, ', ');
                }
            }
            return surveyId;
        }
        window.genericExports = {
            checkReady: function () {
                // REP-4423 - orphaned scheduled reports can hit this page
                throw new Error("This page is not exportable: " + $ctrl.errorCode);
            },
            prepareForExport: function () {
                // Define this so that GE doesn't wait forever for it to be defined
            }
        };
    }
    module.component('prErrorMessage', {
        templateUrl: error_message_html_1.default,
        controller: ErrorMessageController,
        bindings: {
            errorCode: '<'
        }
    });
})(angular_1.module('qualtrics.pr'));
